<template>
  <div class="chats">
    <div
      v-for="(message, index) in messages"
      :key="message.ref"
      class="chat"
      :class="{
        'chat-left': message && message.participant && message.participant.participantType != 'merchant'
      }"
    >
      <div
        v-if="
          message.messageType == messageType.text ||
          message.messageType == messageType.system ||
          message.messageType == messageType.attachment
        "
      >
        <div class="chat-avatar">
          <b-avatar
            v-if="!message.messageType == messageType.system"
            size="36"
            class="avatar-border-2 box-shadow-1"
            variant="light-primary"
            :src="message.profileUrl"
          >
            <feather-icon
              v-if="
                !message.profileUrl &&
                !message.messageType == messageType.system
              "
              icon="UserIcon"
              size="22"
            />
            <svg
              v-if="message.messageType == messageType.system"
              width="76px"
              height="76px"
              viewBox="-286.72 -286.72 1597.44 1597.44"
              class="icon"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              fill="#000000"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0" />
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <g id="SVGRepo_iconCarrier">
                <path
                  d="M859.4 365.7c-8.9 0-17.5 1.3-25.7 3.7-32-148.2-164.1-259.7-321.7-259.7S222.2 221.2 190.3 369.4c-8.2-2.4-16.8-3.7-25.7-3.7-50.4 0-91.4 41-91.4 91.4v109.7c0 50.4 41 91.4 91.4 91.4s91.4-41 91.4-91.4V438.8c0-141.2 114.8-256 256-256s256 114.8 256 256v109.7c0 92.1-48.9 175.4-127.1 221-16.6-23.1-43.7-38.1-74.2-38.1H457c-50.4 0-91.4 41-91.4 91.4 0 50.4 41 91.4 91.4 91.4h109.7c42.9 0 79-29.8 88.8-69.7 81.6-39.6 141.8-109.7 169.2-193.1 10.7 4.4 22.4 6.8 34.7 6.8 50.4 0 91.4-41 91.4-91.4V457.1c0.1-50.4-41-91.4-91.4-91.4zM182.9 566.9c0 10.1-8.2 18.3-18.3 18.3s-18.3-8.2-18.3-18.3V457.1c0-10.1 8.2-18.3 18.3-18.3s18.3 8.2 18.3 18.3v109.8z m383.8 274.3H457c-10.1 0-18.3-8.2-18.3-18.3 0-10.1 8.2-18.3 18.3-18.3h109.7c10.1 0 18.3 8.2 18.3 18.3 0 10.1-8.2 18.3-18.3 18.3z m311-274.3c0 10.1-8.2 18.3-18.3 18.3s-18.3-8.2-18.3-18.3V457.2c0-10.1 8.2-18.3 18.3-18.3s18.3 8.2 18.3 18.3v109.7z"
                  fill="#470342"
                />
                <path
                  d="M512 658.3c80.7 0 146.3-65.6 146.3-146.3h-73.1c0 40.3-32.8 73.1-73.1 73.1S439 552.3 439 512h-73.1c-0.2 80.7 65.4 146.3 146.1 146.3z"
                  fill="#470342"
                />
              </g>
            </svg>
          </b-avatar>
        </div>
        <div class="chat-body">
          <div class="inner-chat-body">
            <div
              v-if="message.participant.id == userData.id"
              class="message-action"
            >
              <!-- <div class="dropdown"> -->
              <b-dropdown variant="link" no-caret toggle-class="p-0" left>
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="17"
                    class="align-middle text-body"
                  />
                </template>
                <!-- assign -->
                <b-dropdown-item @click="confirmDelete(message.id)">
                  {{ $t('button.delete') }}
                </b-dropdown-item>
              </b-dropdown>
              <!-- </div> -->
            </div>
            <div class="chat-group-content">
              <div
                class="chat-content chat-bubble-box-shadow"
                :class="{
                  'p-0': message.messageType == messageType.attachment,
                  matched:
                    activeChannel.latestMessage.isJumping &&
                    activeChannel.latestMessage.createdAt === message.createdAt
                }"
                :style="[
                  isVideo(getFileName(message)) ? { background: 'none' } : {},
                  message.messageType == messageType.attachment && isMultipleMedia(message) ? { background: '' } : {}
                ]"
                @click="onBubbleClick(message)"
              >
                <div v-if="isTranslate()">
                  <div
                    v-if="message.messageType == 1 || message.messageType == 5"
                    class="pt-0"
                  :class="{ 'has-multiple-media': message.messageType == messageType.attachment && isMultipleMedia(message) }"
                  >
                    <!-- this div will show at above original message when messsage is translated, is merchant  -->
                    <span
                      v-if="
                        (systemTranslatedMessage(message) ||
                          message.translatedMessage) &&
                        message.participant.participantType == 'merchant'
                      "
                    >
                      <div class="d-flex">
                        <p class="pre-formatted w-100 float-left">
                          {{
                            systemTranslatedMessage(message) ||
                            message.translatedMessage
                          }}

                          <span class="float-right">
                            <flag
                              v-if="
                                (systemTranslatedLanguage(message) ||
                                  message.translatedLanguage) &&
                                message.messageType == messageType.text
                              "
                              :iso="
                                getCountryCode(
                                  systemTranslatedLanguage(message) ||
                                    message.translatedLanguage
                                )
                              "
                              :squared="false"
                            />
                          </span>
                        </p>
                      </div>
                      <hr style="margin: 4px" />
                    </span>
                  </div>
                </div>
                <div class="d-flex justify-content-between d-chat-container">
                  <div
                    class="message-content d-flex align-items-center w-100"
                    :class="`${
                      message.messageType == messageType.attachment &&
                      !isVideo(getFileName(message)) &&
                      !isMultipleMedia(message)
                        ? 'chat-image'
                        : ''
                    } ${
                      message.messageType == messageType.attachment
                        ? `cursor-pointer`
                        : ``
                    }`"
                  >
                    <div
                      v-if="message.messageType == messageType.attachment"
                      class="message-attachment"
                      :style="[
                        isVideo(getFileName(message)) 
                        && !isMultipleMedia(message)
                          ? { marginBottom: '-5px' }
                          : {}
                      ]
                      
                      "
                    >
                      <!-- multiple mediaIds -->
                      <template v-if="isMultipleMedia(message)">
                        <div class="attachments-card">
                          <div
                            v-for="(m, idx) in getMediaItems(message)"
                            :key="m.mediaId || m._id || idx"
                            class="attc-row"
                            @click.stop="openMedia(m)"
                          >
                            <div class="attc-thumb">
                              <img v-if="isImageMedia(m)" :src="m.url" />
                              <video v-else-if="isVideoMedia(m)" muted>
                                <source :src="m.url" />
                              </video>
                              <template v-else>
                                <file-icon :style="{ color: 'gray' }" />
                                <span class="file-ext" :style="{ color: 'white' }">{{ getFileExtDisplay(getDisplayName(m, message)) }}</span>
                              </template>
                            </div>
                            <div class="attc-meta">
                              <div class="attc-name" :title="getDisplayName(m, message)">
                                {{ getDisplayName(m, message) }}
                              </div>
                              <div class="attc-sub">{{ getMediaSubtext(m) }}</div>
                            </div>
                          </div>
                        </div>
                      </template>

                      <!-- single file fallback (original UI) -->
                      <template v-else>
                        <img
                          v-if="isImage(getFileName(message))"
                          :src="getPrimaryUrl(message) || message.fileUrl || (message.file ? createObjectURL(message.file) : '')"
                          class="img-fluid cursor-pointer p-10 small-image-preview"
                          style="max-width: 80px; object-fit: cover;"
                        />
                        <video
                          v-else-if="isVideo(getFileName(message))"
                          class="rounded"
                          :style="{ width: '100%', maxWidth: '250px' }"
                          controls
                        >
                          <source :src="getPrimaryUrl(message) || createObjectURL(message.file)" />
                          Your browser does not support HTML5 video.
                        </video>
                        <div
                          v-else-if="isDoc(getFileName(message))"
                          class="p-1 small-file-preview"
                          :style="{ position: 'relative' }"
                          :class="{
                            fillSvgBlack:
                              message.participant.participantType != 'merchant'
                          }"
                        >
                          <file-icon :style="{ color: 'gray' }" />
                          <span class="file-ext" :style="{ color: 'white' }">
                            {{ getFileExtDisplay(getFileName(message)) }}
                          </span>
                        </div>
                        <div v-else-if="isAudio(getFileName(message))" class="voice-wrapper">
                          <div class="wave-voice">
                            <WaveSurferVoice
                              :key="getPrimaryUrl(message)"
                              :url="getPrimaryUrl(message)"
                              icon-inner-color="white"
                              icon-outer-color="#8d5185"
                            />
                          </div>
                        </div>
                      </template>
                    </div>

                    <!-- <p
                      v-if="
                        !isVideo(getFileName(message)) &&
                        !isAudio(getFileName(message))
                      "
                      class="pre-formatted w-100 float-left"
                    >
                      {{
                        message.messageType == messageType.system
                          ? message.chatSettings[$i18n.locale.split('-')[0]]
                            ? message.chatSettings[$i18n.locale.split('-')[0]]
                            : message.chatSettings['en']
                            ? message.chatSettings['en']
                            : message.message
                          : message.message
                      }}

                      <span
                        v-if="message.quotaMessage"
                        class="d-flex quota-message"
                      >
                        <strong>{{ message.quotaMessage }}</strong>
                      </span>
                    </p> -->
                    <div
                      v-if="
                        !isVideo(getFileName(message)) &&
                        !isAudio(getFileName(message)) &&
                        !(message.messageType == messageType.attachment && isMultipleMedia(message))
                      "
                      class="w-100 float-left overflow-hidden"
                    >
                      <p
                        class="pre-formatted"
                        v-html="
                          formatMessageWithLinks(
                            message.messageType == messageType.system
                              ? message.chatSettings[$i18n.locale.split('-')[0]]
                                ? message.chatSettings[$i18n.locale.split('-')[0]]
                                : message.chatSettings['en']
                                ? message.chatSettings['en']
                                : message.message
                              : message.message
                          )
                        "
                      />
                      <span
                        v-if="message.quotaMessage"
                        class="d-flex quota-message"
                      >
                        <div class="quota-message-content">
                          <feather-icon
                            icon="CornerDownRightIcon"
                            size="14"
                            class="quota-icon"
                          />
                          <strong>{{ message.quotaMessage }}</strong>
                        </div>
                      </span>
                    </div>
                  </div>
                  <div
                    v-if="isTranslate()"
                    :style="{
                      display: 'flex',
                      'align-items':
                        message.participant.participantType == 'customer'
                          ? 'flex-end'
                          : 'flex-start'
                    }"
                  >
                    <!-- this div show flag at origin message -->
                    <span
                      class="float-right"
                      style="margin-left: 5px"
                      v-if="
                        (message.detectedLanguage ||
                          systemDetectedLanguage(message)) &&
                        message.messageType == messageType.text
                      "
                    >
                      <flag
                        :iso="
                          getCountryCode(
                            message.detectedLanguage ||
                              $i18n.locale.split('-')[0]
                          )
                        "
                        :squared="false"
                      />
                    </span>
                  </div>
                </div>
                <!-- {{ message }} -->

                <div v-if="isTranslate()">
                  <div
                    v-if="message.messageType == messageType.text"
                    class="pt-0"
                  >
                    <span v-if="!message.translatedMessage"
                      ><!-- this span will show when message not yet translate -->
                      <p class="pre-formatted w-100 float-left">
                        <b-button
                          :disabled="loading[index]"
                          class="cursor-pointer btn btn-success btn-sm"
                          style="padding: 4px !important; font-size: 10px"
                          @click="onTranslate(index)"
                          :id="index"
                        >
                          <span v-if="!loading[index]">{{
                            $t('chat.translate')
                          }}</span>
                          <span v-else>{{ $t('general.loading') }}</span>
                        </b-button>
                      </p>
                    </span>
                    <span
                      v-else-if="
                        message.participant.participantType == 'customer'
                      "
                    >
                      <hr style="margin: 4px" />
                      <div class="d-flex">
                        <!-- this div will show after user click on button translate from above -->
                        <p class="pre-formatted w-100 float-left">
                          {{ message.translatedMessage }}
                        </p>
                        <span class="float-right">
                          <flag
                            v-if="
                              message.translatedLanguage &&
                              message.messageType == messageType.text
                            "
                            :iso="getCountryCode(message.translatedLanguage)"
                            :squared="false"
                          />
                        </span>
                      </div>
                    </span>
                  </div>
                </div>
                <div
                  v-if="
                    message.messageType == messageType.attachment &&
                    message.uploadPercentage &&
                    message.uploadPercentage < 100 &&
                    message.sentStatus == messageStatus.sending
                  "
                  class="text-center rounded"
                  :style="{
                    position: 'relative',
                    backgroundColor: '#bbb',
                    fontSize: '10px',
                    height: '1rem',
                    marginTop: !isDoc(getFileName(message)) ? '0px' : '.5rem'
                  }"
                >
                  <div
                    class="loading rounded"
                    :style="{
                      width: `${message.uploadPercentage}%`,
                      height: '1rem',
                      position: 'absolute',
                      left: '-1px',
                      backgroundColor: isVideo(getFileName(message))
                        ? '#8d5185'
                        : '#ac88b3'
                    }"
                  />
                  <span :style="{ position: 'relative' }">
                    {{ message.uploadPercentage }}%
                  </span>
                </div>
              </div>
              <div
                v-if="message.sentStatus == messageStatus.fail"
                class="fail-icon"
                :class="{
                  'cusor-pointer':
                    activeChannel.state == conversationStatus.open
                }"
                @click="retrySendMessage(index)"
              >
                <feather-icon
                  icon="AlertCircleIcon"
                  class="cursor-pointer text-danger"
                  size="22"
                />
              </div>
              <div
                v-else-if="
                  isAudio(getFileName(message)) &&
                  !transcribeContent[message.id]
                "
                class="transcribe-container"
              >
                <button
                  :id="message.id"
                  type="button"
                  class="btn btn-primary btn-voice-to-text"
                  :disabled="transcribeLoading[message.id]"
                  @click="transcribeMessage(message.id)"
                >
                  <b-spinner v-if="transcribeLoading[message.id]" small />
                  <span v-else>{{ $t('voice_to_text') }}</span>
                </button>
              </div>
              <p
                v-if="isAudio(getFileName(message))"
                class="transcribe-content"
              >
                {{
                  transcribeContent[message.id] === 'NOT_AVAILABLE'
                    ? $t('speech_not_clear')
                    : transcribeContent[message.id]
                }}
              </p>
            </div>
          </div>
          <small class="chat-content chat-time">
            <span
              v-if="message.sentStatus == messageStatus.fail"
              class="text-danger"
            >
              {{ $t('chat.fail') }}
            </span>
            <span v-else-if="message.sentStatus == messageStatus.sending">
              {{ $t('chat.sending') }}
            </span>
            <span v-else-if="message.sentStatus == messageStatus.fail">
              <b-button size="sm" variant="link" class="p-0" @click="retrySendMessage(index)">{{ $t('chat.retry') }}</b-button>
            </span>
            <span v-else>
              <span
                v-if="
                  message.id == readMessage &&
                  message.participant.participantType == 'merchant'
                "
              >
                {{ $t('chat.seen') }}
              </span>
              {{ message.createdAt | formatShortDate }}
            </span>
          </small>
        </div>
      </div>
      <div
        v-else-if="
          message.messageType == messageType.status ||
          message.messageType == messageType.autoTranslate
        "
        class="chat-information"
      >
        <div v-if="message.message == 'action.rate'" class="badge-chat">
          <span v-if="message.rateData.comment || message.participant.comment">
            {{
              $t(message.message, {
                visitor: activeChannel.name,
                rate: message.participant.comment
                  ? message.participant.rate
                  : message.rateData.rate,
                comment: message.participant.comment || message.rateData.comment
              })
            }}
          </span>
          <span v-else>
            {{
              $t('action.rateNoComment', {
                visitor: activeChannel.name,
                rate: message.participant.rate || message.rateData.rate
              })
            }}
          </span>
        </div>
        <div v-else-if="message.message == 'action.end'" class="badge-chat">
          {{
            $t(message.message, {
              operator: message && message.participant &&  message.participant.name
                ? message.participant.name
                : $t('general.system')
            })
          }}
        </div>
        <div
          v-else-if="message.message == 'action.transferring'"
          class="badge-chat"
        >
          {{ actionTransfer() }}
          <b>{{ mapTransferMerchantName(message.createdAt) }}</b>
        </div>
        <div
          v-else-if="message.message == 'action.endByCustomer'"
          class="badge-chat"
        >
          {{ $t('action.endByCustomer') }}
        </div>
        <div v-else class="badge-chat">
          {{
            $t(message.message, {
              operator: message && message.participant && message.participant.isBot ? 
                message.participant.botType == botType.ADVANCED ? 
                  $t('chat.aiAssistant') : $t('chat.chatBot') 
                : message.participant.name,
              minute: message.participant.closeDuration
            })
          }}
        </div>
        <div class="text-center">
          <small v-if="index == 0 && message.message == 'action.start'">
            {{ message.createdAt | formatDate }}
          </small>
          <small v-else>{{ message.createdAt | formatShortDate }}</small>
        </div>
      </div>
      <div
        v-if="message.messageType == messageType.joint"
        class="user-profile"
        :style="{
          height: message.profileUrl ? `140px` : `auto`
        }"
      >
        <img
          v-if="message.profileUrl"
          :src="message.profileUrl"
          class="img-fluid rounded-circle"
          alt="Avatar"
          :style="{
            'object-fit': 'cover'
          }"
        />
        <p v-if="message.participant">
          <span class="text-primary" v-if="message.participant && message.participant.isBot">
            <span v-if="message.participant.botType == botType.ADVANCED">
                  {{$t('chat.aiAssistant')}}
            </span>
            <span v-else>
              {{$t('chat.chatBot')}}
            </span>
          </span>
          <span class="text-primary" v-else>{{ message.participant.name }}</span>
          {{ $t('chat.joined') }}
        </p>
        <small>
          {{ message.createdAt | formatShortDate }}
        </small>
      </div>
    </div>
    <div v-if="isTyping" class="chat chat-left">
      <div class="chat-message">
        <div class="chat-avatar">
          <b-avatar
            size="36"
            class="avatar-border-2 box-shadow-1"
            variant="light-primary"
          >
            <feather-icon icon="UserIcon" size="22" />
          </b-avatar>
        </div>
        <div class="chat-body">
          <div class="chat-content chat-bubble-box-shadow">
            <div class="typing">
              <div class="dot" />
              <div class="dot" />
              <div class="dot" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <image-preview :image="image" :album="previewAlbum" :album-index="previewAlbumIndex" @close="onClosePreview" />
  </div>
</template>

<script>
  import {
    BAvatar,
    BButton,
    BDropdown,
    BDropdownItem,
    BPopover,
    BSpinner
  } from 'bootstrap-vue';
  import DOMPurify from 'dompurify';
  import messageStatus from '@/data/messageStatus';
  import messageType from '@/data/messageType';
  import botType from '@/data/botType';
  import conversationStatus from '@/data/conversationStatus';
  import languageEn from '@/data/languages/en';
  import CsvIcon from '@/components/icons/CsvIcon.vue';
  import FileIcon from '@/components/icons/FileIcon.vue';
  import ExcellIcon from '@/components/icons/ExcellIcon.vue';
  import MsWordIcon from '@/components/icons/MsWordIcon.vue';
  import PdfIcon from '@/components/icons/PdfIcon.vue';
  import { getCountryByLanguageCode } from '@/libs/helper';
  import localeCountries from '@/data/localeCountries';
  import useJwt from '@/auth/jwt/useJwt';
  import Repository from '@/repositories/RepositoryFactory';
  import WaveSurferVoice from '@/components/WaveSurferVoice.vue';
  import {
    isVideo,
    isDoc,
    isImage,
    isCsv,
    isExcel,
    isPdf,
    isWord,
    isAudio,
    getFileExtDisplay
  } from '../../helpers/fileHelper';
  import ImagePreview from './ImagePreview.vue';

  const TranslateRepository = Repository.get('translateRepository');
  const ChatMessageRepository = Repository.get('chatMessage');

  export default {
    components: {
      BAvatar,
      ImagePreview,
      BButton,
      BDropdown,
      BDropdownItem,
      BPopover,
      BSpinner,

      CsvIcon,
      ExcellIcon,
      MsWordIcon,
      PdfIcon,
      FileIcon,
      WaveSurferVoice
    },
    props: {
      activeChannel: {
        type: Object,
        default: () => ({})
      },
      messages: {
        type: Array,
        default: () => []
      },
      readMessage: {
        type: String,
        default: ''
      },
      isTyping: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        botType,
        image: '',

        messageStatus,
        messageType,
        conversationStatus,
        loading: {},
        transcribeContent: {},
        showTranscribe: {},
        transcribeLoading: {},
        transcribeError: {},
        previewAlbum: [],
        previewAlbumIndex: 0,
      };
    },
    computed: {
      userData() {
        return this.$store.state.profile.email ||
          this.$store.state.profile.phone
          ? this.$store.state.profile
          : JSON.parse(
              localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
            );
      }
    },
    methods: {
      getPrimaryUrl(message) {
        // prefer explicit media_url
        if (message.mediaUrl) return message.mediaUrl
        // support camelCase converted mediaIds from server
        if (Array.isArray(message.mediaIds) && message.mediaIds.length) {
          return message.mediaIds[0]?.url
        }
        // legacy arrays
        if (Array.isArray(message.mediaUrls) && message.mediaUrls.length) {
          return message.mediaUrls[0]
        }
        if (Array.isArray(message.mediaFiles) && message.mediaFiles.length) {
          return message.mediaFiles[0]?.url || message.mediaFiles[0]
        }
        return null
      },
      isMultipleMedia(message) {
        if (Array.isArray(message.mediaIds) && message.mediaIds.length > 1) return true
        if (Array.isArray(message.files) && message.files.length > 1) return true
        return false
      },
      getMediaItems(message) {
        if (Array.isArray(message.mediaIds) && message.mediaIds.length) return message.mediaIds
        if (Array.isArray(message.files) && message.files.length) {
          return message.files.map(file => ({
            url: file.url || this.createObjectURL(file),
            fileName: file.fileName || file.name,
            fileType: file.fileType || file.type,
            fileSize: file.fileSize || file.size,
          }))
        }
        return []
      },
      extractFileName(url = '') {
        try {
          return url.split('?')[0].split('/').pop()
        } catch (e) {
          return url
        }
      },
      openMedia(media) {
        if (!media?.url) return
        if (this.isImageMedia(media)) {
          // Build album from current message (images + videos)
          const currentMsg = this.messages.find(m => Array.isArray(m.mediaIds) && m.mediaIds.some(id => id.url === media.url))
          if (currentMsg) {
            const items = this.getMediaItems(currentMsg)
            this.previewAlbum = items.map(it => ({ url: it.url, type: this.isVideoMedia(it) ? 'video' : 'image' }))
            this.previewAlbumIndex = items.findIndex(it => it.url === media.url)
          } else {
            this.previewAlbum = [{ url: media.url, type: 'image' }]
            this.previewAlbumIndex = 0
          }
          this.image = media.url
        } else if (this.isVideoMedia(media)) {
          this.openFile(media.url)
        } else {
          this.openFile(media.url)
        }
      },
      openMediaFirst(message) {
        const list = this.getMediaItems(message)
        if (!list.length) return
        const first = list[0]
        if (this.isImageMedia(first)) {
          this.image = first.url
          return
        }
        this.openFile(first.url)
      },
      isImageMedia(m) {
        if (m?.fileType) return m.fileType?.startsWith('image/')
        return this.isImage(m?.url)
      },
      isVideoMedia(m) {
        if (m?.fileType) return m.fileType?.startsWith('video/')
        return this.isVideo(m?.url)
      },
      getMediaSubtext(m) {
        if (typeof m?.fileSize === 'number') {
          return this.formatBytes(m.fileSize)
        }
        return ''
      },
      getDisplayName(m, message) {
        // Prefer server provided name; fallback to optimistic local file name
        if (m?.fileName) return m.fileName
        if (Array.isArray(message?.files)) {
          const idx = (message.mediaIds || []).findIndex(x => x.url === m.url)
          if (idx > -1 && message.files[idx]?.fileName) return message.files[idx].fileName
        }
        return this.extractFileName(m?.url)
      },
      formatBytes(bytes) {
        if (!bytes && bytes !== 0) return ''
        const sizes = ['B', 'KB', 'MB', 'GB']
        let i = 0
        let val = bytes
        while (val >= 1024 && i < sizes.length - 1) {
          val /= 1024
          i++
        }
        return `${val.toFixed(1)} ${sizes[i]}`
      },
      formatMessageWithLinks(message) {
        if (!message) return '';

        // Clean up any existing HTML tags first
        message = message.replace(/<[^>]*>/g, '');

        // Find URLs that aren't already in markdown format
        const urlPattern = /(https?:\/\/[^\s]+)/g;
        const markdownLinkPattern = /\[([^\]]+)\]\(([^)]+)\)/g;

        // First, protect markdown-style links
        let markdownLinks = [];
        message = message.replace(markdownLinkPattern, match => {
          markdownLinks.push(match);
          return `###MDLINK${markdownLinks.length - 1}###`;
        });

        // Convert plain URLs to markdown format
        message = message.replace(urlPattern, url => {
          if (!url.startsWith('[')) {
            return `[${url}](${url})`;
          }
          return url;
        });

        // Restore protected markdown links
        markdownLinks.forEach((link, index) => {
          message = message.replace(`###MDLINK${index}###`, link);
        });

        // Convert markdown links to HTML and sanitize
        const htmlContent = message.replace(
          markdownLinkPattern,
          (_, text, url) =>
            `<a href="${url}" target="_blank" rel="noopener noreferrer">${text}</a>`
        );

        // Sanitize the HTML content
        return DOMPurify.sanitize(htmlContent, {
          ALLOWED_TAGS: ['a'],
          ALLOWED_ATTR: ['href', 'target', 'rel'],
          ALLOW_UNSAFE_ATTR: false
        });
      },
      confirmDelete(messageId) {
        this.$bvModal
          .msgBoxConfirm(this.$t('alert.deleteThisMessage'), {
            title: this.$t('alert.areYouSure'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'primary',
            okTitle: this.$t('button.delete'),
            cancelTitle: this.$t('button.cancel'),
            cancelVariant: 'outline-secondary',
            hideHeaderClose: false,
            centered: true
          })
          .then(value => {
            if (value) {
              this.deleteMessage(messageId);
            }
          });
      },
      deleteMessage(messageId) {
        ChatMessageRepository.delete(messageId)
          .then(response => {})
          .then(error => {
            this.isModalOpen = false;
          });
      },
      transcribeMessage(messageId) {
        // Close the popover if it's already opened
        if (this.showTranscribe[messageId]) {
          this.$set(this.showTranscribe, messageId, false);
          return;
        }

        // Set loading to true and show the popover
        this.$set(this.transcribeLoading, messageId, true);
        this.$set(this.showTranscribe, messageId, true);

        // Get the transcribe
        ChatMessageRepository.transcribe(messageId)
          .then(response => {
            this.$set(this.transcribeError, messageId, false);
            this.$set(this.transcribeLoading, messageId, false);
            this.$set(
              this.transcribeContent,
              messageId,
              response?.data?.data || this.$t('no_voice_detected')
            );
          })
          .then(error => {
            this.$set(this.transcribeLoading, messageId, false);
            this.$set(this.transcribeError, messageId, true);
          });
      },
      systemTranslatedMessage(message) {
        return message?.chatSettings?.translatedMessage;
      },
      systemDetectedLanguage(message) {
        return message?.chatSettings?.detectedLanguage;
      },
      systemTranslatedLanguage(message) {
        return message?.chatSettings?.translatedLanguage;
      },
      actionTransfer() {
        if (this.activeChannel?.transferredFrom) {
          return this.$t('action.transferringFrom');
        }
        return this.$t('action.transferringTo');
      },

      mapTransferMerchantName(createdAt) {
        if (this.activeChannel?.transferredFrom) {
          return this.activeChannel.transferredFromName || 'N/A';
        }
        if (this.activeChannel?.transferred) {
          const transferring = this.activeChannel.transferred.find(
            e =>
              e.startedAt <= createdAt && (!e.endedAt || createdAt <= e.endedAt)
          );
          if (transferring) {
            return transferring?.toName || 'NO NAME';
          }
        }
        return 'N/A';
      },
      getCountryCode(language) {
        return this.localeCountries.find(
          e => e.language.toLowerCase() === language?.toLowerCase()
        )?.flag;
      },
      isTranslate() {
        return (
          this.activeChannel.isAutoTranslate ||
          JSON.parse(localStorage.getItem('chatSettings')).isTranslationOn == 1
        );
      },
      getEmoji(target) {
        if (target == null) {
          return;
        }
        const data = this.getCountryByLanguageCode(this.languageEn, target);
        return data?.emoji;
      },
      createObjectURL(file) {
        return window.URL.createObjectURL(file);
      },
      openFile(url) {
        if (!url) return;
        window.open(url, '_blank');
      },
      getFileName(message) {
        // Prefer actual file name for type detection; fallback to URL
        return message.file?.name || this.getPrimaryUrl(message);
      },
      viewImage(message) {
        const image = this.getPrimaryUrl(message)
        if (image) {
          this.image = image
        }
      },
      onBubbleClick(message) {
        // If multi-media, ignore bubble click (items handle their own click)
        if (message.messageType == this.messageType.attachment && this.isMultipleMedia(message)) {
          return
        }
        const name = this.getFileName(message)
        if (this.isImage(name)) {
          this.viewImage(message)
        } else if (this.isDoc(name)) {
          this.openFile(message.mediaUrl)
        }
      },
      retrySendMessage(index) {
        if (this.activeChannel.state == this.conversationStatus.open) {
          this.$emit('retry', index);
        }
      },
      onTranslate(index) {
        // this.$emit("translate", index);
        this.$set(this.loading, index, true);

        const message = this.messages[index];
        const target = this.$i18n.locale;
        TranslateRepository.translate({ text: message.message, target })
          .then(response => {
            this.messages[index].translatedMessage =
              response?.data?.data?.translatedMessage;
            this.messages[index].translatedLanguage =
              response?.data?.data?.translatedLanguage;
            this.messages[index].detectedLanguage =
              response?.data?.data?.detectedLanguage;
            this.chatBoxKey += 1;
            this.$set(this.loading, index, false);
          })
          .catch(err => {
            this.$set(this.loading, index, false);
          });
      },
      onClosePreview() {
        this.image = ''
        this.previewAlbum = []
        this.previewAlbumIndex = 0
      }
    },
    setup() {
      return {
        getCountryByLanguageCode,
        languageEn,
        localeCountries,
        isImage,
        isVideo,
        isDoc,
        isCsv,
        isExcel,
        isPdf,
        isWord,
        isAudio,
        getFileExtDisplay
      };
    }
  };
</script>

<style lang="scss">
  .wave-voice {
    width: 100%;
    height: 100%;
    padding: 0.5rem 1rem 0.5rem 1rem;
  }

  .attachments-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 6px;
    max-width: 260px;
  }

  .attachment-item {
    position: relative;
    overflow: hidden;
    border-radius: 6px;
    background: rgba(0, 0, 0, 0.08);
    cursor: pointer;
    img, video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  .attachments-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 220px;
    max-width: 320px;
  }

  .attachments-card {
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 260px;
    max-width: 420px;
    padding: 8px;
  }

  .attc-row {
    display: flex;
    align-items: center;
    gap: 12px;
    background: none;
    border-radius: 10px;
    padding: 0;
    cursor: pointer;
  }

  .attc-thumb {
    width: 48px;
    height: 48px;
    border-radius: 8px;
    overflow: hidden;
    background: #e9ecef;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    position: relative;
  }

  .attc-thumb img,
  .attc-thumb video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .attc-meta {
    min-width: 0;
  }

  .attc-name {
    font-weight: 600;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .attc-sub {
    font-size: 10px;
    opacity: 0.7;
  }

  .att-row {
    display: flex;
    align-items: center;
    gap: 10px;
    background: rgba(0,0,0,0.05);
    border-radius: 8px;
    padding: 6px 8px;
    cursor: pointer;
  }

  .att-row .thumb {
    width: 44px;
    height: 44px;
    border-radius: 6px;
    overflow: hidden;
    background: #e9ecef;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .att-row .thumb img,
  .att-row .thumb video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .att-row .meta {
    min-width: 0;
  }

  .att-row .name {
    font-weight: 500;
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .att-row .sub {
    font-size: 11px;
    opacity: 0.8;
  }

  .voice-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 0.5rem 1rem 0.5rem 0;
  }

  .custom-chat .chat-left .chat-group-content {
    display: flex;
    align-items: start;
    flex-direction: row-reverse;
    width: 100%;
    gap: 1rem;
  }

  .btn-voice-to-text {
    font-size: 12px;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .bs-popover-bottom > .arrow::after {
    border-bottom-color: #fdfdfd !important;
  }

  .popover .popover-body {
    border-radius: 0.358rem;
    border: none;
  }

  .transcribe-container {
    height: 50px;
    display: flex;
    align-items: center;
  }

  .transcribe-container button {
    min-width: 8rem;
    max-height: 2.25rem;
    display: flex;
    white-space: nowrap;
    align-items: center;
    justify-content: center;
  }

  .transcribe-content {
    max-width: 40%;
    min-height: 50px;
    display: flex;
    align-items: center;
    margin: 0;
  }

  .quota-message {
    width: 100%;
    border: 0;
    border-top: 1px solid;
    border-style: dashed;
    margin-top: 0.5rem !important;
    padding-top: 0.2rem;
  }

  .chat-content {
    a {
      text-decoration: underline;
      word-break: break-all;
      opacity: 0.9;
      transition: all 0.2s ease;

      // For right side chat (merchant)
      .chat:not(.chat-left) & {
        color: white;

        &:hover {
          opacity: 1;
          text-decoration: none;
          background-color: rgba(255, 255, 255, 0.1);
          border-radius: 4px;
          padding: 2px 4px;
          margin: 0 -4px;
        }
      }

      // For left side chat (customer)
      .chat-left & {
        color: linear-gradient(
          80deg,
          #8d5185,
          #a968a0
        ); // Theme color for left chat

        &:hover {
          opacity: 1;
          text-decoration: none;
          background-color: rgba(71, 3, 66, 0.1); // Theme color with opacity
          border-radius: 4px;
          padding: 2px 4px;
          margin: 0 -4px;
        }
      }
    }
  }
</style>
